import { StylePanelProps } from '@/lib/stylePanel'
import useResponsivePadding from '@/lib/useResponsivePadding'

import styles from './Tabtext.module.css'

export type TabtextProps = {
  title?: string
  subtitle?: string
  content?: string
  button?: React.ReactNode
  tabs?: {
    asset?: {
      src: string
      alt: string
    }
    title?: string
    content?: string
  }[]
  reverse?: boolean
  mobileReverse?: boolean
} & StylePanelProps

export const PhnxTabtext: React.FC<TabtextProps> = ({
  title,
  subtitle,
  content,
  button,
  tabs,
  reverse = true,
  mobileReverse,
  padding,
  backgroundColor,
  textColor,
}) => {
  const paddingStyles = useResponsivePadding(padding)

  const style = {
    ...paddingStyles,
    backgroundColor,
    color: textColor,
  }
  return (
    <div style={style} className="stylepanel">
      {}
      <style jsx>{`
        stylepanel {
          ${paddingStyles}
        }
      `}</style>
      <div
        className={`${styles['tabtext']} ${reverse ? styles['reverse'] : ''} ${mobileReverse ? styles['mobile-reverse'] : ''} container grid-tw-container video-top`}
        data-testid="tabtext"
      >
        <div className={styles['tab-holder']}>
          {tabs &&
            tabs.map((tab, index) => (
              <div key={index} className={styles.tab}>
                {tab.asset && (
                  <div className={styles.asset}>
                    <img src={tab.asset.src} alt={tab.asset.alt} />
                  </div>
                )}
                {tab.title && <div className={styles.title}>{tab.title}</div>}
                {tab.content && <div className={styles.content}>{tab.content}</div>}
              </div>
            ))}
        </div>
        <div className={styles['text-holder']}>
          {title && (
            <div className={`title ${styles.title}`} data-testid="title">
              {title}
            </div>
          )}

          {subtitle && (
            <div className={`${styles.subtitle}`} data-testid="subtitle">
              <p
                dangerouslySetInnerHTML={{
                  __html: subtitle,
                }}
              ></p>
            </div>
          )}

          {content && (
            <div className={styles['content']}>
              <p>{content}</p>
            </div>
          )}

          {button && (
            <div className={styles['button-holder']} data-testid="button">
              {button}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
